import H from 'history'
import { BreachWallContentType, BreachWallStyle } from './BreachWallTypes'
import { BreachWallOptions } from '../components/BreachWallContentWrapper/BreachWallContentWrapper'

function getSummerOfCricketSubTopics() {
    return [
        'cricket',
        'australian-cricket-team',
        'big-bash-league',
        'cricket-world-cup',
        'indian-premier-league',
        'the-ashes',
        'perth-scorchers',
        'womens-cricket',
    ]
}

export interface BreachWallDisplayValues {
    deal: string
    type: BreachWallContentType
    style: BreachWallStyle
}

// 'canShowXXBreach' is created to include topics and subpages, whereas 'otherOptions.canShowXX' is a site wide breach screen
export function getBreachWallOptions(
    location: H.Location,
    otherOptions: BreachWallOptions,
): BreachWallDisplayValues | undefined {
    if (
        canShowFootyLivesHereBreach(
            location,
            otherOptions.canShowBreachDiscountFootyLivesHere,
        )
    ) {
        return {
            deal: 'FootyLivesHere',
            type: 'afl-footy-lives-here-breach-screen',
            style: 'footy-lives-here',
        }
    }
    if (
        canShowSummerOfCricketBreach(
            location,
            otherOptions.canShowSummerOfCricketBreach,
        )
    ) {
        return {
            deal: 'CRKT25_1',
            type: 'summer-of-cricket',
            style: 'summer-of-cricket',
        }
    }
    if (
        canShowSchoolBreach(location, otherOptions.canShowBreachDiscount50sch)
    ) {
        return {
            deal: 'SCHOOL30',
            type: 'top-50-schools',
            style: 'default',
        }
    }
    if (
        canShowBusinessBreach(
            location,
            otherOptions.canShowBusinessPackDiscount,
        )
    ) {
        return {
            deal: 'BUSN2',
            type: 'business-pack',
            style: 'default',
        }
    }
    if (
        canShowSportPackBreach(location, otherOptions.canShowSportPackDiscount)
    ) {
        return {
            deal: 'SP3022',
            type: 'sport-pack',
            style: 'default',
        }
    }
    if (canShowSportBreach(location, otherOptions.canShowSportBreach)) {
        return {
            deal: 'sport',
            type: 'sport',
            style: 'default',
        }
    }
    if (otherOptions.canShowBreachDiscount50Off) {
        return {
            deal: '50-off-campaign',
            type: '50-off-campaign',
            style: '50-off-campaign',
        }
    }
    if (otherOptions.canShowBlackFriday) {
        return {
            deal: 'black-friday',
            type: 'black-friday',
            style: 'black-friday',
        }
    }
    if (otherOptions.canShowAnnualPackage) {
        return {
            deal: 'default-annual-package',
            type: 'default-annual-package',
            style: 'default',
        }
    }

    return undefined
}

// breach checkers

function canShowSportBreach(location: H.Location, canShow: boolean): boolean {
    return canShow && doesStartWithTopic(location, 'sport')
}
function canShowFootyLivesHereBreach(
    location: H.Location,
    canShow: boolean,
): boolean {
    return canShow && doesStartWithTopic(location, 'sport')
}
function canShowSummerOfCricketBreach(location: H.Location, canShow: boolean) {
    return (
        canShow &&
        doesTopicContainSubTopics(location, getSummerOfCricketSubTopics())
    )
}
function canShowSchoolBreach(location: H.Location, canShow: boolean): boolean {
    return canShow && doesTopicContainSubTopic(location, 'top-50-schools')
}
function canShowBusinessBreach(
    location: H.Location,
    canShow: boolean,
): boolean {
    return canShow && doesStartWithTopic(location, 'business')
}
function canShowSportPackBreach(
    location: H.Location,
    canShow: boolean,
): boolean {
    return canShow && doesStartWithTopic(location, 'sport')
}

// topic checkers

export function doesStartWithTopic(
    location: H.Location,
    topic: string,
): boolean {
    const pathName = location.pathname
    return pathName.startsWith('/' + topic)
}
export function doesTopicContainSubTopics(
    location: H.Location,
    subTopics: string[],
): boolean {
    const pathName = location.pathname
    const pathNameSplit = pathName.split('/')
    return pathNameSplit.length > 1
        ? subTopics.filter((subTopic) => pathName.includes(subTopic)).length > 0
        : false
}
export function doesTopicContainSubTopic(
    location: H.Location,
    subTopic: string,
): boolean {
    const pathName = location.pathname
    const pathNameSplit = pathName.split('/')
    return pathNameSplit.length > 1 ? pathName.includes(subTopic) : false
}
